import type { Directive, DirectiveBinding } from "vue";

interface ReClickElement extends HTMLElement {
  disabled: boolean;
  __reClickTimeout?: NodeJS.Timeout;
}

export const reClick: Directive = {
  mounted(el: ReClickElement, binding: DirectiveBinding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        // 禁用元素
        el.disabled = true;

        // 清除已存在的定时器
        if (el.__reClickTimeout) {
          clearTimeout(el.__reClickTimeout);
        }

        // 设置新的定时器启用元素
        const delay = binding.value || 1000; // 默认1秒，而不是3秒
        el.__reClickTimeout = setTimeout(() => {
          el.disabled = false;
          delete el.__reClickTimeout;
        }, delay);
      }
    });
  },

  unmounted(el: ReClickElement) {
    // 组件卸载时清除定时器
    if (el.__reClickTimeout) {
      clearTimeout(el.__reClickTimeout);
      delete el.__reClickTimeout;
    }
  }
};
